import type { Capability } from '@/lib/auth/capabilities';

export const INVESTOR_START_PAGES = [
  { value: 'dashboard', label: 'Command Centre', path: '/investor/dashboard', capabilities: ['investor.dashboard.view'] },
  { value: 'investments', label: 'Portfolio', path: '/investor/investments', capabilities: ['investor.investments.view'] },
  { value: 'data-rooms', label: 'Data Rooms', path: '/investor/data-rooms', capabilities: ['investor.documents.view', 'investor.reports.view'] },
  { value: 'decisions', label: 'Action Centre', path: '/investor/decisions', capabilities: ['gates.view'] },
] as const;

export function availableInvestorStartPages(capabilities: readonly Capability[]) {
  return INVESTOR_START_PAGES.filter(page => page.capabilities.some(capability => capabilities.includes(capability)));
}

/** Preferences never create authority, accept arbitrary URLs, or intercept deep links. */
export function resolveInvestorStartPage(preference: unknown, capabilities: readonly Capability[]): string {
  const available = availableInvestorStartPages(capabilities);
  return available.find(page => page.value === preference)?.path ?? available[0]?.path
    ?? (capabilities.includes('investor.notifications.view') ? '/investor/notifications' : '/investor/settings');
}
